<template>
    <div>
        <h3 class="heading text-center no-margin">{{form.general.name}}</h3>
        <app-general-section v-model="form.general"></app-general-section>
        <app-tags-section label="Tags"  v-model="form"></app-tags-section>
        <br/>
        <app-address-section v-model="form.address"></app-address-section>
        <app-device-modal-footer @click="submit">Salvar</app-device-modal-footer>
    </div>
</template>

<script>
    import AppDeviceModalFooter from './DeviceModalFooter'
    import AppAddressSection from './sections/AddressSection'
    import AppGeneralSection from './sections/GeneralSection'
    import EventBus from '@packages/event-bus'
    import AppTagsSection from '@components/user-modal/components/sections/TagsSection'

    export default {
        components: {
            AppDeviceModalFooter,
            AppAddressSection,
            AppGeneralSection,
            AppTagsSection
        },

        data() {
            return {
                listEstablishment:[],
                deviceTypes: [
                    {id: 'MIKROTIK', label: 'MIKROTIK'}
                ],
                timeoutTypes:[
                    {id: 'MINUTO', label: 'MINUTO'},
                    {id: 'HORA', label: 'HORA'},
                    {id: 'DIA', label: 'DIA'},
                ],

                step: null,

                form: {
                    address:{},
                    general:{
                        deviceType: 'MIKROTIK',
                        timeoutType : 'HORA',
                    },
                },
            }
        },

        mounted() {
            EventBus.$on('RESET_DEVICE_EDIT_MODAL', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_DEVICE_EDIT_MODAL', this.reset)
        },

        methods: {
            reset(params) {
                this.form = params.device
            },

            async submit() {
                await this.$api.devices.update(this.form)
                EventBus.$emit(`LOAD_DEVICES`)
                this.$emit('close')
            },


        },

    }

</script>

<style lang="scss" scoped>
    .flex {
        justify-content: space-between;
    }
</style>
